import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Button from 'builder/components/Button'

export const Container = styled.div`
  margin: auto;
  height: fit-content;
  width: fit-content;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.White};

  ${Media.Tablet`
    margin-top: 30px;
    width: 100%;
  `};

  ${Media.Phone`
    margin-top: 24px;
    padding: 0 20px 32px;
  `};
`

export const Title = styled.p`
  ${Typography.L};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export const Content = styled.div`
  display: flex;
  gap: 65px;
  margin-top: 12px;

  ${Media.Tablet`
    flex-direction: column;
    gap: 36px;
    width: 100%;
  `};

  ${Media.Phone`
    gap: 28px;
  `};
`

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;

  ${Media.Tablet`
    max-width: unset;
    padding: 0 32px;
  `};

  ${Media.Phone`
    padding: 0;
  `};
`

export const Subtitle = styled.p`
  ${Typography.Body};
  color: ${Colors.Neutral90};
  margin-top: 32px;

  ${Media.Tablet`
    margin-top: 0;
  `};
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;

  ${Media.Phone`
    margin-top: 16px;
    gap: 16px;
  `};
`

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${Media.Tablet`
    align-items: flex-start;
  `};

  ${Media.Phone`
    align-items: center;
  `};
`

export const Item = styled.p`
  ${Typography.Body};
  color: ${Colors.Neutral80};

  ${Media.Phone`
    font-size: 15px;
  `};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 32px;
  align-self: flex-start;
  align-items: center;
  margin-top: 24px;

  ${Media.Tablet`
    margin-top: 52px;
  `};

  ${Media.Phone`
    margin-top: 32px;
    flex-direction: column;
    align-self: center;
    width: 100%;
  `};
`

export const PremiumButton = styled(Button)`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.White};
  background-color: ${Colors.Blue50};
  border-radius: 4px;
  width: 206px;
  padding: 12px 24px;

  &:hover {
    background-color: ${Colors.Blue60};
  }

  ${Media.Phone`
    width: 100%;
  `};
`

export const CancelSubcriptionText = styled.p`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral50};
  cursor: pointer;

  ${Media.Phone`
    font-size: 19px;
  `};

  &:hover {
    color: ${Colors.Blue50};
  }
`

export const Header = styled.span`
  color: ${Colors.Neutral50};
  ${Typography.Caps};

  ${Media.Tablet`
    margin-left: 32px;
  `};

  ${Media.Phone`
    margin-left: 0;
  `};
`

export const Items = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;

  ${props =>
    props.$isMobile &&
    `
    display: none;
  `};

  ${props => Media.Tablet`
    ${props.$isMobile ? 'display: flex;' : 'display: none;'}
  `};

  ${Media.Tablet`
    padding-left: 32px;
    padding-right: 100px;
  `};

  ${Media.Phone`
    padding: 0;
  `};
`

export const ItemNumber = styled.div`
  background-color: ${Colors.Blue10};
  color: ${Colors.Blue50};
  border-radius: 100%;
  width: 18px;
  height: 18px;
  justify-content: center;
  align-items: center;
  display: flex;
  ${Typography.Caps};
  ${FontWeights.DemiBold};
`

export const Video = styled.video`
  width: 384px;
  height: 384px;

  ${Media.Tablet`
    width: 326px;
    height: 210px;
    margin: auto;
  `};

  ${Media.Phone`
    width: 100%;
  `};
`
